import { useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { EventForm } from "@/components/EventForm";
import { AISelector } from "@/components/AISelector";
import { PreviewArea } from "@/components/PreviewArea";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Zap, Globe, Code, Sparkles, CheckCircle, Calendar, MapPin, Users, Star } from "lucide-react";
import heroImage from "@/assets/hero-image.jpg";
import { TestimonialsSection } from "@/components/landing/testimonials-section";
import { LandingHeader } from "@/components/landing/landing-header";
import { HeroSection } from "@/components/landing/hero-section";
import { FeaturesSection } from "@/components/landing/features-section";
import { DemoSection } from "@/components/landing/demo-section";
import { PricingSection } from "@/components/landing/pricing-section";
import { CTASection } from "@/components/landing/cta-section";
import { LandingFooter } from "@/components/landing/landing-footer";

interface EventData {
  name: string;
  description: string;
  venue: string;
  location: string;
  date: string;
  time: string;
  capacity: string;
  ticketPrice: string;
  category: string;
  organizer: string;
}

const Index = () => {
  const [selectedAI, setSelectedAI] = useState("claude");
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedCode, setGeneratedCode] = useState<string | null>(null);
  const [currentStep, setCurrentStep] = useState<"form" | "preview">("form");

  const handleGenerate = async (eventData: EventData) => {
    setIsGenerating(true);
    setCurrentStep("preview");

    // Simulate AI generation
    setTimeout(() => {
      setGeneratedCode("// Generated event website code will appear here");
      setIsGenerating(false);
    }, 3000);
  };

  const handleAISelect = (provider: string) => {
    setSelectedAI(provider);
  };

  return (
    <main className="w-full">


      {/* Secondary Hero Section */}
      <section className="w-full relative">
        <HeroSection />
      </section>

      {/* Features Section */}
      <section className="w-full relative">
        <FeaturesSection />
      </section>

      {/* Demo Section */}
      <section className="w-full relative bg-muted/50">
        <DemoSection />
      </section>

      {/* Testimonials Section */}
      <section className="w-full relative">
        <TestimonialsSection />
      </section>

      {/* Pricing Section */}
      <section className="w-full relative bg-muted/50">
        <PricingSection />
      </section>

      {/* CTA Section */}
      <section className="w-full relative">
        <CTASection />
      </section>
    </main>
  );
};

export default Index;
